import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Footer.module.scss'
import commonStyle from '../../style.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IFooterProps {
  showCart: boolean
  onCartClose: () => void
  onItemClose: () => void
  showHint: () => void
  closeSimulation: () => void
}

const Footer = ({ showCart, onCartClose, onItemClose, closeSimulation, showHint }: IFooterProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {!viewport.mobile ? (
        <footer className={style.footer} data-testid="SW-EC-Footer">
          <div className={style.thank}>
            <span className={style.text}>{t('questions', 'ec', 'walmart', 'thank1')}</span>
            <EmptyLink color="#0053e2">
              <button className={style.feedback}>{t('questions', 'ec', 'walmart', 'thank2')}</button>
            </EmptyLink>
          </div>
          <div className={style.main}>
            <div className={style.links}>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'allDepartments')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'storeDirectory')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'careers')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'ourCompany')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'sellOn')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'help')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'recalls')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'accessibility')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'tax')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'getApp')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'signUp')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'safety')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'terms')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'privacy')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'supplyChains')}</EmptyLink>
              <EmptyLink color="#0053e2">
                <span className={style.logo}></span>
                {t('questions', 'ec', 'walmart', 'privacyChoice')}
              </EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'noticeCollection')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'adChoices')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'consumer')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'requestPersonal')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'brandShop')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'pharmacy')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'business')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'iywyk')}</EmptyLink>
              <EmptyLink color="#0053e2">{t('questions', 'ec', 'walmart', 'deleteAccount')}</EmptyLink>
            </div>
            <div className={style.info}>{t('questions', 'ec', 'walmart', 'rightsReserved')}</div>
          </div>
        </footer>
      ) : (
        <footer className={style.navigation} data-testid="SW-EC-Footer">
          <button className={style.item} onClick={showCart ? onCartClose : onItemClose}>
            <div className={style.shopLogo}>
              <svg width="1024" height="1024" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    fill="white"
                    d="M512 571.392q10.24 0 16.384 4.096t8.192 10.24l12.288 139.264q0 10.24-11.264 17.408t-25.6 7.168-25.6-7.168-11.264-17.408l12.288-139.264q2.048-6.144 9.216-10.24t15.36-4.096z"
                  ></path>
                  <path
                    fill="white"
                    d="M612.352 514.048l124.928 59.392q10.24 4.096 11.264 17.408t-6.144 25.6-19.456 18.432-20.48 2.048l-114.688-81.92q-4.096-4.096-5.12-12.288t4.096-15.36 12.288-11.264 13.312-2.048z"
                  ></path>
                  <path
                    fill="white"
                    d="M425.984 516.096q6.144 4.096 11.264 12.288t4.096 15.36-5.12 11.264l-114.688 79.872q-8.192 6.144-20.48 0t-19.456-18.432-6.144-25.6 11.264-17.408l124.928-59.392q6.144-2.048 14.336 2.048z"
                  ></path>
                  <path
                    fill="white"
                    d="M722.944 333.824q12.288 6.144 19.456 18.432t6.144 25.6-11.264 17.408l-124.928 59.392q-6.144 2.048-13.312-2.048t-12.288-11.264-4.096-15.36 5.12-12.288l114.688-81.92q8.192-4.096 20.48 2.048z"
                  ></path>
                  <path
                    fill="white"
                    d="M321.536 331.776l114.688 81.92q4.096 4.096 4.096 12.288t-4.096 15.36-11.264 11.264-13.312 2.048l-124.928-59.392q-10.24-4.096-11.264-17.408t6.144-25.6 19.456-18.432 20.48-2.048z"
                  ></path>
                  <path
                    fill="white"
                    d="M512 219.136q14.336 0 25.6 7.168t11.264 17.408l-12.288 139.264q-2.048 6.144-9.216 10.24t-15.36 4.096-15.36-4.096-9.216-10.24l-12.288-139.264q0-10.24 11.264-17.408t25.6-7.168z"
                  ></path>
                </g>
              </svg>
            </div>
            <svg width="1024" height="1024" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path
                  fill="#0053e2"
                  d="M530.432 77.824l237.568 178.176h159.744q14.336 0 23.552 9.216t9.216 23.552v671.744h-385.024v-225.28h-126.976v225.28h-385.024v-671.744q0-14.336 9.216-23.552t23.552-9.216h159.744l237.568-178.176q8.192-6.144 18.432-6.144t18.432 6.144z"
                />
              </g>
            </svg>
            <span className={style.textActive}>{t('questions', 'ec', 'walmart', 'shop')}</span>
          </button>
          <EmptyLink color="#0053e2">
            <div className={style.item}>
              <i className="wm-Reorder" />
              <span>{t('questions', 'ec', 'walmart', 'myItems')}</span>
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.item}>
              <i className="wm-Search" />
              <span>{t('questions', 'ec', 'walmart', 'search')}</span>
            </div>
          </EmptyLink>
          <>
            <div className={style.item}>
              <div className={`${commonStyle.IconAytmPlace} ${style.aytmItem}`}>
                <i className=" icon-aytmfd-help" onClick={showHint} />
              </div>
            </div>
          </>
          <>
            <div className={style.item}>
              <div className={`${commonStyle.IconAytmPlace} ${style.aytmItem}`}>
                <i className=" icon-aytmfd-exit" onClick={closeSimulation} />
              </div>
            </div>
          </>
        </footer>
      )}
    </>
  )
}

export default Footer
